module.exports = __webpack_public_path__ + "hard.f60260a6.png";